const constraints = {
  firstName: {
    presence: { allowEmpty: false, message: 'is required' },
    length: { minimum: 3, maximum: 50, message: 'must be at least 3 and less than 50 characters' },
  },
  lastName: {
    presence: { allowEmpty: false, message: 'is required' },
    length: { minimum: 3, maximum: 50, message: 'must be at least 3 and less than 50 characters' },
  },
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
  },
};

export default constraints;
